export async function readCsvFile(file) {
    if (file.type !== 'text/csv') {
        return;
    }
    const reader = new FileReader();
    reader.readAsText(file);
    const out = new Promise((resolve) => {
        reader.addEventListener('load', async (e) => {
            var _a;
            resolve((_a = reader.result) === null || _a === void 0 ? void 0 : _a.toString());
        });
    });
    return out;
}
